<template>
  <div>
    <vs-popup
      :active.sync="isPopupActiveLocal"
      classContent="popup-example"
      title="Stok ekle"
      fullscreen
    >
      <vs-card>
        <b-row style="margin-bottom: 50px">
          <b-col>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group :label="'* Firma'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="firma"
                  type="text"
                  name="title"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('firma')">{{
                  errors.first("firma")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'* Stok Adı'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="stokName"
                  type="text"
                  name="stokName"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('stokName')">{{
                  errors.first("stokName")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'* Stok Kodu'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="stokKodu"
                  type="text"
                  name="stokKodu"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('stokKodu')">{{
                  errors.first("stokKodu")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'* Barkod'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="barkod"
                  type="text"
                  name="barkod"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('barkod')">{{
                  errors.first("barkod")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Barkod 2'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="barkod2" type="text" name="barkod" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Ortak Kod'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="ortakKod" type="text" name="ortakKod" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Ortak Kod Adı'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="ortakKodName" type="text" name="title" />
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Adet'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="adet" type="text" name="adet" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'* Fiyat'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="fiyat"
                  type="text"
                  name="fiyat"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('fiyat')">{{
                  errors.first("fiyat")
                }}</span>
              </b-col>
            </b-row>

            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Satış Fiyat'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="satisFiyat" type="text" name="fiyat" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Maliyet'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="maliyet" type="text" name="maliyet" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Döviz'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="doviz" type="text" name="title" />
              </b-col>
            </b-row>

            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Kdv'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input
                  size="small"
                  v-model="kdv"
                  type="text"
                  name="kdv"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('kdv')">{{
                  errors.first("kdv")
                }}</span>
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Beden'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="beden" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Renk'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="renk" type="text" name="title" />
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Açıklama'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="aciklama" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Kategori'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="kategori" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Marka'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="marka" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Kargo Süresi'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="kargoSuresi" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Alan 1 (navlun)'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="alan1" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Alan 2 (desi)'" label-for="h-first-name">
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="alan2" type="text" name="title" />
              </b-col>
            </b-row>
            <b-row style="margin-top: 10px">
              <b-col cols="4" align-self="center">
                <b-form-group :label="'Alan 3'" label-for="h-first-name"> </b-form-group>
              </b-col>
              <b-col cols="8">
                <vs-input size="small" v-model="alan3" type="text" name="title" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <b-button
              v-if="editControl"
              style="background-color: #ff9f43; border-color: #ff9f43"
              v-on:click="stockKaydet('edit')"
            >
              <Icon
                style="margin-right: 5px"
                icon="material-symbols:done-all-rounded"
                width="20"
                height="20"
                v-b-tooltip.hover.bottom="'Stoğu Güncelle'"
              />Güncelle
            </b-button>
            <b-button
              v-else
              style="background-color: #ff9f43; border-color: #ff9f43"
              v-on:click="stockKaydet()"
            >
              <Icon
                style="margin-right: 5px"
                icon="material-symbols:done-all-rounded"
                width="20"
                height="20"
                v-b-tooltip.hover.bottom="'Stoğu Kaydet'"
              />Kaydet
            </b-button>
          </vs-row>
        </div>
      </vs-card>
    </vs-popup>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import { Validator } from "vee-validate";
export default {
  data() {
    return {
      firma: "",
      stokName: "",
      stokKodu: "",
      barkod: "",
      barkod2: "",
      ortakKod: "",
      ortakKodName: "",
      adet: "",
      fiyat: "",
      satisFiyat: "",
      maliyet: "",
      doviz: "",
      kdv: "",
      beden: "",
      renk: "",
      aciklama: "",
      kategori: "",
      marka: "",
      kargoSuresi: "",
      alan1: "",
      alan2: "",
      alan3: "",
      editControl: false,
    };
  },
  props: ["isPopupActive", "data"],
  computed: {
    isPopupActiveLocal: {
      get() {
        return this.isPopupActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
  created() {
    const dict = {
      custom: {
        firma: {
          required: "Firma gereklidir",
          alpha: "Firma gereklidir",
        },
        stokName: {
          required: "Stok adı gereklidir",
          alpha: "Stok adı gereklidir",
        },
        stokKodu: {
          required: "Stok kodu gerklidir",
          alpha: "Stok kodu gerklidir",
        },
        barkod: {
          required: "Barkod gereklidir",
          alpha: "Barkod gereklidir",
        },
        ortakKod: {
          required: "Ortak kod gereklidir",
          alpha: "Ortak kod gereklidir",
        },
        adet: {
          required: "Adet gerklidir",
          alpha: "Adet gerklidir",
        },
        fiyat: {
          required: "Fiyat gereklidir",
          alpha: "Fiyat gereklidir",
        },
        kdv: {
          required: "Kdv gereklidir",
          alpha: "Kdv gereklidir",
        },
      },
    };
    Validator.localize("en", dict);
  },
  watch: {
    isPopupActive(val) {
      if (typeof this.data == "undefined") {
        this.editControl = false;
        this.firma = "";
        this.stokName = "";
        this.stokKodu = "";
        this.barkod = "";
        this.barkod2 = "";
        this.ortakKod = "";
        this.ortakKodName = "";
        this.adet = "";
        this.fiyat = "";
        this.satisFiyat = "";
        this.maliyet = "";
        this.doviz = "";
        this.kdv = "";
        this.beden = "";
        this.renk = "";
        this.ciklama = "";
        this.kategori = "";
        this.marka = "";
        this.kargoSuresi = "";
        this.alan1 = "";
        this.alan2 = "";
        this.alan3 = "";
      } else {
        this.editControl = true;
      }
      console.log(this.editControl);

      return val;
    },
    data(val) {
      console.log(val);

      this.firma = val.firma;
      this.stokName = val.stokName;
      this.ortakKod = val.ortakKod;
      this.ortakKodName = val.ortakKodName;
      this.stokKodu = val.stokKodu;
      this.barkod = val.Barkod;
      this.barkod2 = val.barkod2;
      this.adet = val.adet;
      this.fiyat = val.fiyat;
      this.satisFiyat = val.satisFiyat;
      this.maliyet = val.maliyet;
      this.doviz = val.doviz;
      this.kdv = val.kdv;
      this.beden = val.beden;
      this.renk = val.renk;
      this.aciklama = val.aciklama;
      this.kategori = val.kategori;
      this.marka = val.marka;
      this.kargoSuresi = val.kargoSuresi;
      this.alan1 = val.alan1;
      this.alan2 = val.alan2;
      this.alan3 = val.alan3;

      return val;
    },
  },
  methods: {
    stockKaydet(edit) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let param = {
            edit: edit,
            firma: this.firma,
            stokName: this.stokName,
            ortakKod: this.ortakKod,
            ortakKodName: this.ortakKodName,
            stokKodu: this.stokKodu,
            barkod: this.barkod,
            barkod2: this.barkod2,
            adet: this.adet,
            fiyat: this.fiyat,
            satisFiyat: this.satisFiyat,
            maliyet: this.maliyet,
            doviz: this.doviz,
            kdv: this.kdv,
            beden: this.beden,
            renk: this.renk,
            aciklama: this.aciklama,
            kategori: this.kategori,
            marka: this.marka,
            kargoSuresi: this.kargoSuresi,
            alan1: this.alan1,
            alan2: this.alan2,
            alan3: this.alan3,
          };
          this.$root.$emit("addXmlStock", param);
        } else {
          vs.notify({
            text: "Gerkli alanları doldurunuz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
  },
  components: {
    Icon,
  },
};
</script>
